import type { AuthenticatedUserPayload } from '@Application/Security/Authentications/Actions/userAuthenticated';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AuthenticatedUserView {
	readonly id: number;
	readonly email: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly role: AuthenticatedUserPayload['role'];
	readonly account: AuthenticatedUserPayload['account'];

	constructor(payload: AuthenticatedUserPayload) {
		this.id = payload.id;
		this.email = payload.email;
		this.firstName = payload.firstName;
		this.lastName = payload.lastName;
		this.role = payload.role;
		this.account = payload.account;

		Object.freeze(this);
	}

	get fullName(): string {
		return `${this.firstName} ${this.lastName}`;
	}
}

export default AuthenticatedUserView;
